import React, { useState, useCallback, ChangeEvent, useEffect, memo } from 'react';
import { BarraPesquisa } from '..';
import { CategoriaTabs } from '../cardapio-categoria-tabs'
import { AppBar, Fade } from '@material-ui/core';
import { Carregando } from 'components';
import { useHistory } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { useStyles } from './cardapio-header-navbar-styles';
import { ProdutoCategoriaModel } from 'api/cardapio/models/produto-categoria/produto-categoria-model';
import { useMesaStore } from 'services/store/mesa-store';
import { useConfirm } from 'material-ui-confirm';
import { VariaveisAmbiente } from 'ambiente';
import { EnumDeviceType } from 'ambiente/ambiente-tipos';
import { GetAuthLoginRedirect } from 'utils';
import { CardapioDadosProps } from '../../cardapio-header/cardapio-header-props';
import { EnumDialogs, useDialogStore } from 'services/store/dialog-store';
import { CardapioHeaderNavbarOptions } from './components/cardapio-header-navbar-options/cardapio-header-navbar-options';
import { usePedidos } from 'services/providers/pedidos-provider';
import { useObterToken } from 'services/store/obter-token';
import { TokenGestaoEmpresaTipoEnum } from 'api/master/models/token/token-gestao-empresa-model';

export interface CardapioHeaderNavBarProps {
  categorias?: Array<ProdutoCategoriaModel>;
  categoriaSelecionada?: string;
  referencia?: any;
  categoriaClick: (categoria: string) => any;
  quandoPesquisar?: (event: ChangeEvent<HTMLInputElement>) => any;
  logout: () => any;
  abrirPedidoResumo: () => any;
  setConfigurando: () => void;
  cardapioDados: CardapioDadosProps | undefined
  visualizacao: 'configuracao' | 'gerarQrCode' | 'cardapio' | 'acompanharPedido'
}

export const CardapioHeaderNavBar = memo(({
  categorias,
  categoriaSelecionada,
  referencia,
  categoriaClick,
  quandoPesquisar,
  logout,
  abrirPedidoResumo,
  setConfigurando,
  cardapioDados,
  visualizacao
}: CardapioHeaderNavBarProps) => {

  const { configuracoes, empresa, configuracoesDelivery } = cardapioDados!;
  const mesa = useMesaStore(state => state.mesa);
  const getMesaId = useMesaStore(state => state.getMesaId);
  const { location } = useHistory();
  const mesaId = getMesaId(location.pathname);
  const openCloseDialog = useDialogStore(state => state.openCloseDialog);

  // DEPENDENCIAS
  const { rotaValida, getTokenTipo } = useObterToken()
  const usuarioToken = useObterToken(state => state.getTokenConvert())
  const adminLogado = rotaValida() && getTokenTipo() === TokenGestaoEmpresaTipoEnum.Operador
  const history = useHistory();
  const capa = configuracoes.capa
  const confirm = useConfirm();

  // STATES E STYLES
  const [pesquisa, definirPesquisa] = useState(false);
  const classes = useStyles({ capa, categorias, pesquisa, visualizacao });
  const [carregando, setCarregando] = useState(false);
  const [mostrarCategorias, setMostrarCategorias] = useState(false);
  const { getPedido } = usePedidos()

  useEffect(() => {
    if (configuracoes.tipoUsoCardapio === 2) {
      getPedido();
    }
  }, [configuracoes.tipoUsoCardapio, getPedido])

  useEffect(() => {
    setTimeout(() => {
      setMostrarCategorias(
        isEmpty(categorias) === false && Array.isArray(categorias) && visualizacao === 'cardapio',
      );
    }, 1);
  }, [categorias, visualizacao]);

  useEffect(() => {
    if (adminLogado) {
      definirPesquisa(false);
    }
  }, [adminLogado]);

  const onVisualizarClick = useCallback(() => {
    history.push(`/${empresa.id}`);
  }, [history, empresa]);

  const onEditarConfiguracoesClick = useCallback(() => {
    setConfigurando();
  }, [setConfigurando]);

  const onPesquisaClick = React.useCallback(() => {
    definirPesquisa((prev) => !prev);
  }, []);

  const onClickMesa = React.useCallback(() => {
    let title = 'Sem Mesa Vinculada';
    let description = `Você não possuí uma mesa vinculada. Para vincular, leia o QRCode de uma mesa pelo seu dispositivo.
      Para vincular à um dispositivo da loja, contate um administrador.`

    if (mesaId) {
      title = `Mesa ${mesa?.codigo} Vinculada`;
      if (VariaveisAmbiente.deviceType === EnumDeviceType.NAVIGATOR) {
        description = `Você possui uma mesa vinculada. Para vincular outra, leia um QRCode com seu dispositivo.`
      } else if (!adminLogado) {
        description = `Para vincular outra mesa no dispositivo, contate um administrador.`
      } else {
        description = ``
      }
    }
    if (!adminLogado) {
      if (VariaveisAmbiente.deviceType === EnumDeviceType.CORDOVA) {
        openCloseDialog(EnumDialogs.Autenticar, true, {
          callback: () => {
            openCloseDialog(EnumDialogs.SelecionarMesa, true);
          }
        });
      } else {
        window.location.assign(GetAuthLoginRedirect());
      }
      return;
    }
    confirm({
      title,
      description,
      cancellationText: 'Cancelar',
      confirmationText: 'Configurar',
    }).then(() => {
      openCloseDialog(EnumDialogs.SelecionarMesa, true);
    })
  }, [mesaId, adminLogado, confirm, mesa?.codigo, openCloseDialog])

  return (
    <>
      <AppBar
        ref={referencia}
        position="static"
        className={classes.appBar}
        style={{ transition: 'height 0.3s ease-in-out !important' }}
        color="default"
        elevation={4}
      >
        <CardapioHeaderNavbarOptions
          {...{
            capa,
            empresa,
            adminLogado,
            configuracoes,
            logout,
            mesa,
            mesaId,
            onClickMesa,
            onEditarConfiguracoesClick,
            onPesquisaClick,
            onVisualizarClick,
            setCarregando,
            abrirPedidoResumo,
            quandoPesquisar,
            usuarioToken,
            pesquisa,
            visualizacao,
            configuracoesDelivery
          }}
        />
        <Fade in={mostrarCategorias} mountOnEnter unmountOnExit timeout={200}>
          <CategoriaTabs
            categorias={categorias}
            categoriaClick={categoriaClick}
            categoriaSelecionada={categoriaSelecionada}
          />
        </Fade>

        <BarraPesquisa
          pesquisa={pesquisa && visualizacao === 'cardapio'}
          onPesquisaClick={onPesquisaClick}
          quandoPesquisar={quandoPesquisar}
          modo="dinamic"
        />
      </AppBar>
      <Carregando
        carregando={carregando}
        modelo="fixed"
        titulo={'Carregando...'}
        mensagem={`Aguarde enquanto carregamos a visualização do catálogo...`}
        className={classes.carregando}
      />

    </>
  );
});

CardapioHeaderNavBar.displayName = 'CardapioHeaderNavBar';